import { Observable } from 'rxjs';
import { ApiUrl } from '../api-core/api-constants';
import { apiPost } from '../api-core/api-request';
import apiRequestHookFactory from '../api-core/utility-factories/api-request-hook-factory';
import { apiRedux } from '../api-redux';
import {
  WarrantyCoveredReq,
  WarrantyCoveredRtn,
} from './api-warranty-covered.types';

export const useCreateRepairCaseWarrantyCovered =
  apiRequestHookFactory(
    apiRedux.createRepairCaseWarrantyCovered,
    (data: WarrantyCoveredReq): Observable<WarrantyCoveredRtn> =>
      apiPost<WarrantyCoveredRtn>(
        ApiUrl.REPAIRS_CASE_WARRANTY_COMMENTS,
        data
      )
  );
